import React, { Component } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Motion, spring } from 'react-motion';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';

import ListIcon from '@material-ui/icons/List';
import ApprovedIcon from '@material-ui/icons/ThumbUp';
import SendIcon from '@material-ui/icons/Send';
import PaidIcon from '@material-ui/icons/Receipt';

import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';

import { startAddInvoice } from '../../../store/actions/invoices';
import { startEditAdmin } from '../../../store/actions/admin';

const lightGreen = green[200];
const lightOrange = orange[200];
const lightRed = red[200];

const styles = theme => ({
  root: {
  },
  checked: {
    color: lightGreen,
  },
  greenAvatar: {
    color: '#fff',
    backgroundColor: lightGreen,
  },
  orangeAvatar: {
    color: '#fff',
    backgroundColor: lightOrange,
  },
  redAvatar: {
    color: '#fff',
    backgroundColor: lightRed,
  },
  button: {
    width: '100px',
  }
});

//TODO: refactor
class InvoiceTask extends Component {
  constructor(props){
    super(props);
    const { type } = props;

    switch (type) {
      case "create":
        this.state = {...this.createState(props)};
        break;
      case "approve":
        this.state = {...this.approveState(props)};
        break;
      case "send":
        this.state = {...this.sendState(props)};
        break;
      case "pay":
        this.state = {...this.payState(props)};
        break;
      default:
        this.state = {
          avatar: undefined,
          avatarStyle: undefined,
          title: "",
          subheading: "",
          checked: false,
          focus: false
        };
    }
  }

  createState({classes, invoice, schedule, type}) {
    const result = {
      type: type,
      avatar: <ListIcon />,
      avatarStyle: undefined,
      title: "Create Invoice",
      subheading: "",
      checked: false
    };

    if (invoice !== undefined) {
      result.subheading = <Moment format="[Created on ] ddd MMM Do">{invoice.createdDate}</Moment>;
      result.checked = true;
      result.avatarStyle = classes.greenAvatar;
    } else {
      result.checked = false;
      const invoiceDueDate = new Date(schedule.date.getYear(), schedule.date.getMonth() + 1, 0);
      if (invoiceDueDate < new Date()){
        result.subheading = "Overdue";
        result.avatarStyle = classes.redAvatar;
      } else {
        result.subheading = <Moment format="[Create by ] ddd MMM Do">{invoiceDueDate}</Moment>;
        result.avatarStyle = classes.orangeAvatar;
      }
    }

    return result;
  }

  approveState({classes, invoice, schedule, type}) {
    const result = {
      type: type,
      avatar: <ApprovedIcon />,
      avatarStyle: undefined,
      title: "Approve Invoice",
      subheading: "Not Approved",
      checked: false
    };

    if (invoice !== undefined && invoice.isApproved) {
      result.subheading = "Approved";
      result.checked = true;
      result.avatarStyle = classes.greenAvatar;
    } else if (invoice !== undefined){
      result.avatarStyle = classes.orangeAvatar;
    }

    return result;
  }

  sendState({classes, invoice, schedule, type}) {
    const result = {
      type: type,
      avatar: <SendIcon />,
      avatarStyle: undefined,
      title: "Send Invoice",
      subheading: "Not Sent",
      checked: false
    };

    if (invoice !== undefined){
      if (invoice.statuses.sent) {
        result.subheading = "Sent";
        result.checked = true;
        result.avatarStyle = classes.greenAvatar;
      } else if (invoice.isApproved) {
        result.subheading = "Not Sent";
        result.avatarStyle = classes.orangeAvatar;
      }
    }

    return result;
  }

  payState({classes, invoice, schedule, type}) {
    const result = {
      type: type,
      avatar: <PaidIcon />,
      avatarStyle: undefined,
      title: "Apply Payment",
      subheading: "Not Paid",
      checked: false
    };

    if (invoice !== undefined){
      if (invoice.isPaid) {
        result.subheading = "Paid";
        result.checked = true;
        result.avatarStyle = classes.greenAvatar;
      } else if (invoice.statuses.sent) {
        result.subheading = "Not Paid";
        result.avatarStyle = classes.orangeAvatar;
      }
    }
    return result;
  }

  getAction(classes, invoice, invoiceData, handlePreviewOpen, startEditAdmin) {
    switch (this.state.type) {
      case "create":
        if (invoice === undefined) {
          return (
            <Button
              className={classes.button}
              color="primary"
              variant="raised"
              onClick={() => (
                startAddInvoice(invoiceData)
              )}
             >
               Create
             </Button>
          );
        } else {
          return (
            <Button
              className={classes.button}
              color="primary"
              variant="raised"
              onClick={() => startEditAdmin({invoice: invoice})}
             >
               View
             </Button>
          );
        }

      case "approve":
        return (
          <Button
            className={classes.button}
            color="primary"
            variant="raised"
            onClick={() => startEditAdmin({invoice: invoice})}
           >
             Approve
           </Button>
        );
      case "send":
        return (
          <Button
            className={classes.button}
            color="primary"
            variant="raised"
            onClick={handlePreviewOpen}
           >
             Send
           </Button>
        );
      case "pay":
        return (
          <Button
            className={classes.button}
            color="primary"
            variant="raised"
            onClick={() => startEditAdmin({invoice: invoice})}
           >
             Payment
           </Button>
        );
      default:
    }

  }

  render() {
    const {
      classes,
      invoice,
      schedule,
      project,
      handlePreviewOpen,
      startEditAdmin
    } = this.props;

    const scheduleDate = schedule.scheduleDate;
    const invoiceData = {
      projectId: project.id,
      invoiceDate: scheduleDate,
      createdDate: new Date(),
      scheduleDate: scheduleDate
    };


    const {
      avatar,
      avatarStyle,
      title,
      subheading,
      checked,
      focus
    } = this.state;

    return(
      <ListItem
        dense={false}
        onMouseEnter={() => {
          this.setState({focus: true})
        }}
        onMouseLeave={() => {
          this.setState({focus: false})
        }}
      >
        <Avatar className={avatarStyle}>
          {avatar}
        </Avatar>
        <ListItemText
          primary={title}
          secondary={subheading}
        />
      {!focus &&
        <div>
          <Checkbox
              checked={checked}
              disabled
              classes={{
                 checked: classes.checked,
               }}
            />
        </div>
      }
      {focus &&
        <Motion defaultStyle={{opacity: 0}}
                style={{
                  opacity: spring(1, { stiffness: 15, damping: 10})
                }}>
          {(style) => (
            <div style={{
                   opacity: style.opacity
                 }}
            >
              {this.getAction(classes, invoice, invoiceData, handlePreviewOpen, startEditAdmin)}
            </div>
          )}
        </Motion>
      }
      </ListItem>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startAddInvoice: (invoice) => dispatch(startAddInvoice(invoice)),
  startEditAdmin: (invoice) => dispatch(startEditAdmin(invoice))
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(InvoiceTask);



// WEBPACK FOOTER //
// ./src/components/admin/InvoiceTasks/InvoiceTask.jsx